<div class="modal-content">
  <div class="popup-header">
    <h3>Port Consumption Details</h3>
    <mat-icon class="icon" (click)="closePopup()">close</mat-icon>
  </div>

  <div class="content" [formGroup]="consumptionForm">
    <p class="sub-title">Please fill in port consumption values:</p>

    <div class="table-container">
      <table class="consumption-table">
        <thead>
          <tr>
            <th>Port Consumption</th>
            <th>FO (MT/DAY)</th>
            <th>MGO (MT/DAY)</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>Loading Per Day</td>
            <td><input type="number" formControlName="loadingFO"></td>
            <td><input type="number" formControlName="loadingMGO"></td>
          </tr>

          <tr>
            <td>Discharge per day</td>
            <td><input type="number" formControlName="dischargeFO"></td>
            <td><input type="number" formControlName="dischargeMGO"></td>
          </tr>

          <tr>
            <td>Discharging in US ports</td>
            <td><input type="number" formControlName="usPortFO"></td>
            <td><input type="number" formControlName="usPortMGO"></td>
          </tr>

          <tr>
            <td>Idle Per day</td>
            <td><input type="number" formControlName="idleFO"></td>
            <td><input type="number" formControlName="idleMGO"></td>
          </tr>

          <tr>
            <td>Harbour steaming</td>
            <td><input type="number" formControlName="harbourFO"></td>
            <td><input type="number" formControlName="harbourMGO"></td>
          </tr>

          <tr>
            <td>Tank Cleaning</td>
            <td><input type="number" formControlName="tankFO"></td>
            <td><input type="number" formControlName="tankMGO"></td>
          </tr>

          <tr>
            <td>Inerting per day</td>
            <td><input type="number" formControlName="inertingFO"></td>
            <td><input type="number" formControlName="inertingMGO"></td>
          </tr>

          <tr>
            <td>COW (Crude oil washing 8 hrs)</td>
            <td><input type="number" formControlName="cowFO"></td>
            <td><input type="number" formControlName="cowMGO"></td>
          </tr>

          <tr>
            <td>Heating maintain temperature</td>
            <td><input type="number" formControlName="heatMaintainFO"></td>
            <td><input type="number" formControlName="heatMaintainMGO"></td>
          </tr>

          <tr>
            <td>Heating raise temperature</td>
            <td><input type="number" formControlName="heatRaiseFO"></td>
            <td><input type="number" formControlName="heatRaiseMGO"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="button-container submitBtn">
      <button class="hover-clear btn" (click)="saveConsumption()">Save</button>
      <button class="hover-clear btn" (click)="closePopup()">Cancel</button>
    </div>
  </div>
</div>